import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const productionAPI = {
    // Get all production lots with optional filters
    getAll: async (page, pageSize, status, searchTerm, brandId) => {
        try {
            const params = { page, pageSize };
            if (status) params.status = status;
            if (searchTerm) params.searchTerm = searchTerm;
            if (brandId) params.brandId = brandId;
            const { data } = await api.get('/api/production-lots/', { params });
            return data;
        } catch (error) {
            handleApiError(error, 'Get production lots error:');
        }
    },

    // Get a single production lot by ID
    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/production-lots/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get production lot error:');
        }
    },

    // Start a new production lot from a recipe
    startProduction: async (recipeId, productionData) => {
        try {
            const { data } = await api.post(`/api/recipes/${recipeId}/start-production/`, productionData);
            return data;
        } catch (error) {
            handleApiError(error, 'Start production error:');
        }
    },

    // Cancel a production lot
    cancel: async (id) => {
        try {
            const { data } = await api.post(`/api/production-lots/${id}/cancel/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Cancel production lot error:');
        }
    },

    // Add more inventory to a production lot
    addInventory: async (id, allocations) => {
        try {
            const { data } = await api.post(`/api/production-lots/${id}/add-inventory/`, { allocations });
            return data;
        } catch (error) {
            handleApiError(error, 'Add inventory to production error:');
        }
    },

    // Return inventory from a production lot
    returnInventory: async (id, returns) => {
        try {
            const { data } = await api.post(`/api/production-lots/${id}/return-inventory/`, { returns });
            return data;
        } catch (error) {
            handleApiError(error, 'Return inventory from production error:');
        }
    },

    // Dispose inventory from a production lot
    disposeInventory: async (id, disposals) => {
        try {
            const { data } = await api.post(`/api/production-lots/${id}/dispose-inventory/`, { disposals });
            return data;
        } catch (error) {
            handleApiError(error, 'Dispose inventory from production error:');
        }
    },

    // Finalize a production lot
    finalize: async (id, finalizationData) => {
        try {
            const { data } = await api.post(`/api/production-lots/${id}/finalize/`, finalizationData);
            return data;
        } catch (error) {
            handleApiError(error, 'Finalize production lot error:');
        }
    },

    correctIngredient: async (id, corrections, destinationLocationId) => {
        try {
            const { data } = await api.post(`/api/production-lots/${id}/correct-ingredient/`, {
                correction_type: 'reduce_quantity',
                corrections,
                destination_location_id: destinationLocationId,
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Correct production ingredient error:');
        }
    },

    addMissingItem: async (id, additions) => {
        try {
            const { data } = await api.post(`/api/production-lots/${id}/correct-ingredient/`, {
                correction_type: 'add_item',
                additions,
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Add missing item to production error:');
        }
    },

    correctOutputQuantity: async (id, newOutputQuantity) => {
        try {
            const { data } = await api.post(`/api/production-lots/${id}/correct-ingredient/`, {
                correction_type: 'correct_output',
                new_output_quantity: newOutputQuantity,
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Correct output quantity error:');
        }
    },
};
